var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-office-txt"},[_c('div',{ref:"rootRef",staticClass:"vue-office-txt-main",attrs:{"id":"vue-office-txt-main"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }